import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { OuiButton } from 'omnium-ui/button';
import { OuiDialogModule } from 'omnium-ui/dialog';
import { QpiIconBoxComponent } from '../qpi-icon-box/qpi-icon-box.component';

export interface QpiCspUpdateDialogData {
  isValid: boolean;
  missingFields?: string[];
}

@Component({
  selector: 'app-qpi-csp-update-dialog',
  imports: [OuiDialogModule, OuiButton, QpiIconBoxComponent],
  templateUrl: './qpi-csp-update-dialog.component.html',
  styleUrl: './qpi-csp-update-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QpiCspUpdateDialogComponent {
  readonly data: QpiCspUpdateDialogData = inject(MAT_DIALOG_DATA);

  readonly errorMessage: string = this.getMissingFieldsErrorMessage(this.data.missingFields);

  private getMissingFieldsErrorMessage(missingFields?: string[]): string {
    if (!missingFields || missingFields.length == 0)
      return "Votre recueil d'information doit être complété pour le calcul de la capacité à supporter des pertes.";

    return `Votre recueil d'information doit être complété des informations suivantes pour le calcul de la capacité à supporter des pertes : ${missingFields.join(', ')}`;
  }
}
